import classNames from 'classnames'
import { Dropdown, IDropdownProps } from 'legacy/lut/library/dropdown'
import { JSX } from 'react'

import { createComponentFn } from 'onboarding/components/helpers/createComponentFn'
import themesStyles from 'onboarding/components/themes.module.scss'

type TComponentFn = (props: IDropdownProps) => JSX.Element

const applyDisabled = (component: TComponentFn) => {
  return (props: IDropdownProps) => {
    const { disabled, classes } = props
    const disabledTheme = disabled ? themesStyles.disabledDropdown : undefined

    return component({
      ...props,
      classes: {
        ...classes,
        controlClasses: {
          ...classes?.controlClasses,
          root: classNames(classes?.controlClasses?.root, disabledTheme),
        },
      },
    })
  }
}

export const OnboardingDropdown = (props: IDropdownProps) =>
  applyDisabled(createComponentFn<IDropdownProps & JSX.IntrinsicAttributes>(Dropdown))(props)
